export default "__VITE_ASSET__CBkR0pwc__"